$(function(){

  if($('.howsie_tab01').length){

    $('.howsie_tab01 b').on('click',function(){
      	$(this).siblings().removeClass('active');
      	$(this).toggleClass('active');
    	var ind = $(this).index()+1;
        $(this).closest('.howsie_title').siblings('.howsie_tab_content').find('section').removeClass('ons').css('display','none');
        $(this).closest('.howsie_title').siblings('.howsie_tab_content').find('section:nth-of-type('+ind+')').toggleClass('ons').css('display','block');
    });
  
  }


var timer = false;
$(window).on('load resize', function() {
if (timer !== false) {clearTimeout(timer);}
timer = setTimeout(function() {

if ($(window).width() <= 640) { // SP

if($('#top-categorys .categorys .category_list .category_link_title').length) {
	$('#top-categorys .categorys .category_list .category_link_title').off('click');
	$('#top-categorys .categorys .category_list .category_link_title').on('click',function(){
          $(this).closest('.category_list').siblings('.category_list').find('strong').removeClass('active');
          $(this).closest('.category_list').siblings('.category_list').find('ul').hide();
          $(this).siblings('.category_link').find('span').hide().removeClass('active');
          $(this).find('strong').toggleClass('active');
          $(this).siblings('.category_link').find('ul').slideToggle(100);
          $(this).siblings('.category_link').find('span').slideToggle(100).toggleClass('active');
        return false;
      });
}

} else if ($(window).width() > 640) { // PC

$('#top-categorys .categorys .category_list .category_link_title').off('click');
$('#top-categorys .categorys .category_list').find('.category_link ul').show();
$('#top-categorys .categorys .category_list').find('.category_link span').show().removeClass('active');

}

}, 200);
});



var timer2 = false;
$(window).on('load resize', function() {
if (timer2 !== false) {clearTimeout(timer2);}
timer2 = setTimeout(function() {
if($('.head_search_ct_wrap .categorys .category_list .category_link_title').length) {
	$('.head_search_ct_wrap .categorys .category_list .category_link_title').off('click');
	$('.head_search_ct_wrap .categorys .category_list .category_link_title').on('click',function(){
          $(this).closest('.category_list').siblings('.category_list').find('strong').removeClass('active');
          $(this).closest('.category_list').siblings('.category_list').find('ul').hide();
          $(this).siblings('.category_link').find('span').hide().removeClass('active');
          $(this).find('strong').toggleClass('active');
          $(this).siblings('.category_link').find('ul').slideToggle(100);
          $(this).siblings('.category_link').find('span').slideToggle(100).toggleClass('active');
        return false;
      });
}
}, 200);
});




}); /* // $(function() */

